export const MutationStatuses = {
  IDLE: 'IDLE',
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
};


export const androlofyPatientDetails = [
  {name: 'patientName', label: 'Patient Name', type: 'text', isPrefilled: true,},
  {name: 'spouseName', label: 'Spouse Name', type: 'text'},
  {name: 'patientAge', label: 'Patient Age', type: 'number'},
  {name: 'spouseAge', label: 'Spouse Age', type: 'number'},
  {name: 'MPID', label: 'MPID', type: 'text'},
  {name: 'SpouseMPID', label: 'Spouse MPID', type: 'text'},
  {name: 'referredBy', label: 'Referred By', type: 'text'},
]